import { defineMessages } from 'react-intl';

export default defineMessages({
    contactUs: {
        id: 'ml.common.MLOutOfSequenceConflictComponent.contactUs',
        defaultMessage: '<strong>You are unable to proceed as information conflicts with a prior change. Please contact us to resolve.</strong>'
    },
    unableToProceedCallAgency: {
        id: 'ml.common.MLOutOfSequenceConflictComponent.unableToProceedCallAgency',
        defaultMessage: '<p><strong>You are unable to proceed as information conflicts with a prior change.</strong></p><p>To resolve, please chat or call Agency Resource Center at 1-800-255-0332.</p>'
    }
});